export const email = 'nobody@example.com';

export const rotateCred = {
    rotateCred: true
};

export const preAuthUser = {
    email
};
